import { useEffect } from "react";

import { AppPricingData } from "src/contentful";

import { PricingContentContextProvider } from "@/components/wpl/pricing/src/pricing-content-context";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content";
import { UserLocale } from "@/utils/useGeoCurrency";

import { SoftwareBitbucketPricingPageTemplate } from "../../../../templates/software/bitbucket/pricing/software-bitbucket-pricing-page/src";

// If your page doesn't have props, then obviously don't include this
export type SoftwareBitbucketPricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
};
export const SoftwareBitbucketPricingPage = ({
    pricing,
    countryCode,
    pricingContent
}: SoftwareBitbucketPricingPageProps) => {
    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdPricingAll);
    }, []);

    return (
        <PricingContentContextProvider
            productId="bitbucket"
            pricingContent={pricingContent}
        >
            <div data-testid="bitbucket-pricing-page">
                <SoftwareBitbucketPricingPageTemplate
                    pricing={pricing}
                    countryCode={countryCode}
                />
            </div>
        </PricingContentContextProvider>
    );
};
